import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=63daf154&"
import script from "./StaffManage.vue?vue&type=script&lang=js&"
export * from "./StaffManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports